import type { PathType } from './types';
import { getPath } from './types';

export const administrationPaths: { [key: string]: PathType } = {
  approvalProcess: getPath('/interactive/system-admin/approval-process', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess'
  ]),
  approvalProcessAdd: getPath('/interactive/system-admin/approval-process/add', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess',
    'action.add'
  ]),
  approvalProcessEdit: getPath('/interactive/system-admin/approval-process/edit', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess',
    'action.edit'
  ]),
  approvalProcessDetail: getPath('/interactive/system-admin/approval-process/detail', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.approvalProcess',
    'page.detail'
  ]),
  handleProcess: getPath('/interactive/system-admin/handle-process', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.handleProcess'
  ]),
  handleProcessAdd: getPath('/interactive/system-admin/handle-process/add', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.handleProcess',
    'action.add'
  ]),
  handleProcessEdit: getPath('/interactive/system-admin/handle-process/edit', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.handleProcess',
    'action.edit'
  ]),
  template: getPath('/interactive/system-admin/template', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.template'
  ]),
  templateAdd: getPath('/interactive/system-admin/template/add', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.template',
    'action.add'
  ]),
  templateEdit: getPath('/interactive/system-admin/template/edit', [
    'v2.sidebar.home',
    'sidebar.administration.index',
    'sidebar.administration.template',
    'action.edit'
  ])
};
